import React from 'react';
import { Button, Card, Space, Typography } from 'antd';
import dayjs from 'dayjs';
import { calcularValorTotalVisual } from './cobrancasEventosAcoes';
import DocumentoCobrancaConsolidada from './DocumentoCobrancaConsolidada';

// Fase D.3 -- secao ADITIVA "Cobrancas Consolidadas de Eventos",
// renderizada entre os filtros e a tabela principal de
// CobrancasEventosAdmin.js. Componente "burro" (Secao 5 da instrucao):
// zero HTTP proprio -- `sugestoes`/`grupos` ja' vem calculados (via
// `indexarSugestoesConsolidacao`/`agruparPorGroupId`, useMemo no pai) e
// toda mutacao (formar/dissolver/emitir/reemitir/verificar/cancelar) e'
// delegada aos callbacks.
//
// DOIS BLOCOS (Secao 9 da instrucao): sugestoes (candidatos ainda nao
// agrupados) e Groups ja' formados -- unificados aqui de proposito
// (Secao 15 da investigacao anterior): ambos podem cruzar cards/eventos
// diferentes do MESMO aluno, entao nenhum dos dois pode viver dentro de
// um card de inscricao especifico sem repeticao/ambiguidade.
//
// Fase D.4b -- o bloco de Groups ja' formados delega a apresentacao de
// CADA grupo a `DocumentoCobrancaConsolidada` (componente dedicado,
// autorizacao de botao exclusivamente via `grupoTemAcao`/
// `acoes_permitidas_grupo`, ver docstring la'). Este arquivo permanece
// puramente COMPOSICAO/LISTAGEM -- nunca decide quais botoes aparecem.
//
// `data_vencimento` chega como "YYYY-MM-DD" -- dayjs(...) direto,
// mesmo padrao ja usado em CobrancasEventosAdmin.js.
const formatarDataBR = (dataIso) => (dataIso ? dayjs(dataIso).format('DD/MM/YYYY') : '—');

const formatarValorBRL = (valorNumero) => `R$ ${valorNumero.toFixed(2).replace('.', ',')}`;

const SecaoCobrancasConsolidadas = ({
  sugestoes,
  grupos,
  onVerEConsolidar,
  onDissolver,
  onEmitir,
  onVerificarPagamento,
  onCancelar,
  onVerificarCancelamento,
  onCopiarLinhaDigitavel,
  onEnviarWhatsApp,
  estaAcaoEmAndamento,
}) => {
  if ((!sugestoes || sugestoes.length === 0) && (!grupos || grupos.length === 0)) {
    return null;
  }

  return (
    <Space direction="vertical" style={{ width: '100%', marginBottom: 16 }} size={12}>
      {sugestoes && sugestoes.length > 0 && (
        <Card size="small" title="Sugestões de consolidação nesta página">
          <Typography.Paragraph type="secondary" style={{ fontSize: 12, marginBottom: 12 }}>
            Cobranças compatíveis podem existir em outras páginas — esta lista mostra apenas as encontradas
            na página atual.
          </Typography.Paragraph>
          <Space direction="vertical" style={{ width: '100%' }} size={8}>
            {sugestoes.map((sugestao) => {
              const primeiro = sugestao.componentes[0];
              const total = calcularValorTotalVisual(sugestao.componentes);
              return (
                <div
                  key={sugestao.chave_consolidacao}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 8,
                    padding: '8px 0',
                    borderBottom: '1px solid #f0f0f0',
                  }}
                >
                  <div>
                    <Typography.Text strong>{primeiro.aluno_nome || '—'}</Typography.Text>
                    <div>
                      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                        {sugestao.componentes.length} cobranças podem ser consolidadas · Vencimento{' '}
                        {formatarDataBR(primeiro.data_vencimento)} · Total {formatarValorBRL(total)}
                      </Typography.Text>
                    </div>
                  </div>
                  <Button size="small" type="primary" onClick={() => onVerEConsolidar(sugestao)}>
                    Ver e consolidar
                  </Button>
                </div>
              );
            })}
          </Space>
        </Card>
      )}

      {grupos && grupos.length > 0 && (
        <Card size="small" title="Cobranças consolidadas">
          <Space direction="vertical" style={{ width: '100%' }} size={8}>
            {grupos.map((grupo) => (
              <DocumentoCobrancaConsolidada
                key={grupo.id_financial_charge_group}
                grupo={grupo}
                estaAcaoEmAndamento={estaAcaoEmAndamento}
                onDissolver={onDissolver}
                onEmitir={onEmitir}
                onVerificarPagamento={onVerificarPagamento}
                onCancelar={onCancelar}
                onVerificarCancelamento={onVerificarCancelamento}
                onCopiarLinhaDigitavel={onCopiarLinhaDigitavel}
                onEnviarWhatsApp={onEnviarWhatsApp}
              />
            ))}
          </Space>
        </Card>
      )}
    </Space>
  );
};

export default SecaoCobrancasConsolidadas;
